/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import { adjustPostTags, handleRelatedProducts, handleTopBigSearchAndSearchPopupButton, handleToggleSibling, removeLastSlashFromBreadcrumb, delayShowMobileMagnifyGlass, handleProductFilterDropdown, handleWooCommSortByDropdown, handleSimpleToggle, moveAboutUsServiceCategories, disableMiniCartOnMobile, handleMobileMenuItemClick, hideAllTheseDivs, setGoogleTag, showProductList, handleHomeGallery, handleCaseStudyHeight, setUpMemberForm } from "./functions";
import { handleWooCommerceVariant, MIStore } from "./miStore";
import { makeCollapsibleLists } from "./productCatTree";
import { handleAddToCartOrRequestQuote, handleToggle } from "./productDetail";
import { CookieNoShowGdpr, getCookie, handleButtonGDPRBar, setCookie, setIsOldGDPR, trackingOn } from './cookie_helper';
import listenForClick from "./clickHandler";

jQuery(function(){
	// Must call here, then the select2 show correct value if user click browser back button.
	handleTopBigSearchAndSearchPopupButton("mi-in-page");
	moveAboutUsServiceCategories();
	requestAnimationFrame(() => {
		showProductList();
	});
	handleHomeGallery();
	handleCaseStudyHeight();
	setUpMemberForm();
}); // end of: jQuery(function()

function start(){
	setupExternalMethod_for_handleTopBigSearchAndSearchPopupButton();
	delayShowMobileMagnifyGlass();
	handleToggle();
	handleToggleSibling();
	handleRelatedProducts();
	adjustPostTags();
	handleWooCommerceVariant();
	handleAddToCartOrRequestQuote();
	removeLastSlashFromBreadcrumb();
	makeCollapsibleLists(document.querySelector(".mi-category-tree"));
	handleProductFilterDropdown();
	handleWooCommSortByDropdown();
	handleSimpleToggle();
	disableMiniCartOnMobile();
	// handleMobileMenuItemClick();
	handleOldCloseGDPR();
	setGoogleTag();
	//fakeFormData();
	// These can call even before ready
	handleToggleGroup('mi-toggle');
}

// For the search bar inside mobile popup menu.
// As the popup is instantiated when the mobile menu first show
// Need to call select2 after popup in instantiated. So need this code.
function setupExternalMethod_for_handleTopBigSearchAndSearchPopupButton() {
	{
		let miStore: MIStore = (window as any).miStore;
		/*
		The popup should have a html widget with this content:
		<script type="text/javascript">
			if (window.miStore.forSearchPopup)
				window.miStore.forSearchPopup();
		</script>
		*/
		// Tailor made for the search popup. Need to call just before the popup appear. As the popup's div is generated by elementor javascript.
		miStore.forSearchPopup = () => {
			handleTopBigSearchAndSearchPopupButton("mi-in-popup");
		};
	}
}

// Enable only for testing.
function fakeFormData() {
/////////////
	let formWrapper = document.querySelector(".mi-bordered-form");
	if (!formWrapper)
		return;

	let inputs = formWrapper.querySelectorAll("input");
	(inputs[0] as HTMLInputElement).value = "Bartholomew";
	(inputs[1] as HTMLInputElement).value = "Iu";
	(inputs[2] as HTMLInputElement).value = "99999999";
	(inputs[3] as HTMLInputElement).value = "bartholomew.iu@miracles.com.hk";
	(inputs[4] as HTMLInputElement).value = "Miracle";

	let selects = formWrapper.querySelectorAll("select");
	(selects[0] as HTMLSelectElement).value = "First Choice";
	(selects[1] as HTMLSelectElement).value = "First Choice";

	let textareas = formWrapper.querySelectorAll("textarea");
	(textareas[0] as HTMLTextAreaElement).value = "Some long text.";

	(inputs[5] as HTMLInputElement).checked = true;
//////////
}

function handleOldCloseGDPR(){
	let gdprDivs = document.querySelectorAll(".mi-gdpr");
	if (gdprDivs.length == 0)
		return;

	let firstGdprDiv = gdprDivs[0] as HTMLElement;
	let closeBtn = firstGdprDiv.querySelector("#mi-close-gdpr");
	if (!closeBtn)
		return;

	if (closeBtn)
		setIsOldGDPR();

	if (getCookie(CookieNoShowGdpr) == "1"){
		hideAllTheseDivs(gdprDivs);
		
	}
	else{
		if (closeBtn){
			closeBtn.addEventListener("click", () => {
				hideAllTheseDivs(gdprDivs);
				setCookie(CookieNoShowGdpr, "1");
			});
		}
	}
}

start();




// This is general, will handle all the toggle group.
// Group parent class is mi-toggle-wrapper, can have multiple in same page.
// Controller class inside the group parent: mi-toggle-controller, each with dataset: toggle-target attribute, 
// in this format: data-toggle-target="mi-shop-and-image-$count"
// Controllee class inside the group parent: mi-toggle-controllee
// Some special feature are stored in dataset, check them in code.
function handleToggleGroup(prefix: string){
	let toggleWrappers = document.querySelectorAll('.' +prefix+ '-wrapper');
	if (!toggleWrappers)
		return;

	for (let index = 0, len=toggleWrappers.length; index < len; index++) {
		let toggleWrapper = toggleWrappers[index] as HTMLElement;
	
		let controllers = toggleWrapper.querySelectorAll('.' +prefix+ '-controller');
		let controllees = toggleWrapper.querySelectorAll('.' +prefix+ '-controllee');

		// In html, assume show / hide the controllee won't cause too much layout poping. If need fading, then it is a bit complicated.

		const clickHandler = (currController : HTMLElement) => {
			let toggleTarget = currController.dataset.toggleTarget;

			for (let index = 0, len=controllees.length; index < len; index++) {
				let controllee = controllees[index] as HTMLElement;
				// console.log(JSON.stringify(controllee.classList));
				// console.log(toggleTarget);
				// console.log(controllee.classList.contains(toggleTarget));
				//console.log(controllee);
				if (toggleTarget == controllee.id || controllee.classList.contains(toggleTarget)){
					controllee.classList.remove('mi-display-none-in-play-mode');
					document.body.dispatchEvent(new CustomEvent('toogle-shown'));
				}
				else
					controllee.classList.add('mi-display-none-in-play-mode');
			}

			for (let index = 0, len=controllers.length; index < len; index++) {
				let otherController = controllers[index];
				if (otherController == currController){
					otherController.classList.add('mi-selected');
				}
				else{
					otherController.classList.remove('mi-selected');
				}
			}
		}

		for (let index = 0, len=controllers.length; index < len; index++) {
			let currController = controllers[index] as HTMLElement;
			listenForClick(currController, ()=>{
				clickHandler(currController);
			}, false);
		}

		if (!toggleWrapper.dataset.noDefaultSelect){
			if (controllers.length >= 1){
				// The default selected in first one.
				
				let initIndex = 0;
				let hash = window.location.hash;
				if (hash){
					hash = hash.substr(1); // remove the hash character.
					let hashAsInt = parseInt(hash);
					if (hashAsInt){ // If the hash is #1, then simply use this as init index. If #0, then will ignore it, as if(0) is false.
						if (hashAsInt >= controllers.length)
							hashAsInt = controllers.length - 1;
						initIndex = hashAsInt;
					}
					else{
						let mapping = (window as any).mi_toogle_group_mapping;
						if (mapping){ // The mapping may be not exist.
							for (let index = 0, len=mapping.length; index < len; index++) {
								let rule = mapping[index];
								if (rule[0] == hash){
									initIndex = rule[1];
									break;
								}
							}
						}
					}
				}
				clickHandler(controllers[initIndex] as HTMLElement);
			}
		}
	}
}